export const isInsightsUiHintEnabled = () => (
  String(process.env.REACT_APP_INSIGHTS_ENABLED || '').trim().toLowerCase() === 'true'
);

export const hasInsightsCapability = (features = {}) => features?.insights === true;
